<div class="container">
  <div class="carousel-header">
    @if (title) {
      <h1 class="topic-title">{{title}}</h1>
    }
    <div class="carousel-controls">
      <div class="scroller scroller-left" (click)="scroll('left')" [class.disabled]="!isLeftShown">
        <i-feather name="chevron-left"></i-feather>
      </div>
      <div class="scroller scroller-right" (click)="scroll('right')" [class.disabled]="!isRightShown">
        <i-feather name="chevron-right"></i-feather>
      </div>
    </div>
  </div>
  <div class="carousel d-flex">
    <div class="carousel-content" cdkScrollable #scrollContainer>
      <!-- Padders are used to enable 'overflow' of content without margin-hacking... -->
      <ng-content></ng-content>
    </div>
  </div>
</div>
